import { Link } from "wouter";
import { clarityOneLocalDevHint, getStaffLoginPath } from "@/lib/clarityOneMode";

/** Shown on Clarity One paths when VITE_CLARITY_ONE_DEV is not set locally. */
export default function ClarityOneLocalDevFallback() {
  const hint = clarityOneLocalDevHint();

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl border border-[#E8E4DC] p-8 text-center shadow-sm">
        <h1 className="text-xl font-light text-[#1A2744] mb-3">Clarity One local mode</h1>
        <p className="text-sm text-[#8B7355] leading-relaxed mb-6">
          {hint ??
            "Set VITE_CLARITY_ONE_DEV=true in your .env file and restart the dev server to test Clarity One on localhost."}
        </p>
        <code className="block text-xs bg-[#FAFAF7] border border-[#E8E4DC] rounded-lg px-3 py-2 mb-6 text-left text-[#1A2744]">
          VITE_CLARITY_ONE_DEV=true
        </code>
        <Link
          href={getStaffLoginPath()}
          className="text-sm text-[#C8A96A] hover:underline no-underline"
        >
          Go to staff portal login →
        </Link>
      </div>
    </div>
  );
}
